module.exports = __webpack_public_path__ + "img/imagem-site.f5f1013b.png";